export default {"src":"/_next/static/media/apple-app-store-logo.a2e763b8.svg","height":40,"width":120,"blurWidth":0,"blurHeight":0};